enum NewRequestDataFormKeys {
    COINSURANCE_PARTICIPATION = "coinsurance_participation",
    EXCLUDED_FROM_CONTRACT = "excluded_from_contract",
    SPECIAL_ACEPTATION = "special_aceptation",
    BUILDING = "building",
    BUSINESS_INTERRUPTION = "business_interruption",
    CONTENT = "content",
    TOTAL_SUM_SECURED = "total_sum_secured",
    FLOORS = "floors",
    YEARBUILT = "yearBuilt",
    BEACHFRONT = "beachFront",
    ADDRESS = "address",
    COUNTRY = "country",
    PROVINCE = "province",
    CITY = "city",
    ZIPCODE = "zipcode",
    INSURED_FULLNAME = "insured_fullname",
    ACTIVITY = "activity",
    VALIDITY_FROM = "validity_from",
    VALIDITY_TO = "validity_to",
    AON_SUM_EXTRA = "aon_sum_extra",
    ORIGINAL_TAX = "original_tax",
    ORIGINAL_GROSS_BONUS = "original_gross_bonus",
    ORIGINAL_GROSS_BONUS_PARCIAL = "original_gross_bonus_parcial",
    ORIGINAL_GROSS_AON = "original_gross_aon",
    NOTES = "notes",
    COORDINATE_LAT = "coordinate_lat",
    COORDINATE_LNG = "coordinate_lng",
    MAP = "map"
};

export default NewRequestDataFormKeys;